// Import cover images
import wesAnderson from '@/assets/style-recipes/wes-anderson.avif'
import ecommShine from '@/assets/style-recipes/ecomm-shine.avif'
import founderPortrait from '@/assets/style-recipes/founder-portrait.avif'
import flatVectorSocial from '@/assets/style-recipes/flat-vector-social.avif'
import cute3dToy from '@/assets/style-recipes/cute-3d-toy.avif'
import neonNightlife from '@/assets/style-recipes/neon-nightlife.avif'
import watercolorPost from '@/assets/style-recipes/watercolor-post.avif'
import lowpoly3d from '@/assets/style-recipes/lowpoly-3d.avif'
import corporatePremium from '@/assets/style-recipes/corporate-premium.avif'
import seasonalBoosters from '@/assets/style-recipes/seasonal-boosters.avif'
import rogerDeakins from '@/assets/style-recipes/roger-deakins.avif'
import neonNoir from '@/assets/style-recipes/neon-noir.avif'
import pixarVinylRender from '@/assets/style-recipes/pixar-vinyl-render.avif'
import studioGhibliWatercolor from '@/assets/style-recipes/studio-ghibli-watercolor.avif'
import anthropologieHomeCatalog from '@/assets/style-recipes/anthropologie-home-catalog.avif'
import highFashionEditorialPortrait from '@/assets/style-recipes/high-fashion-editorial-portrait.avif'
import appleKeynoteProduct from '@/assets/style-recipes/apple-keynote-product.avif'
import a24ElevatedHorror from '@/assets/style-recipes/a24-elevated-horror.avif'
import naturalDatingProfile from '@/assets/style-recipes/natural-dating-profile.avif'
import modernCorporatePortrait from '@/assets/style-recipes/modern-corporate-portrait.avif'
import founderBrandingPortrait from '@/assets/style-recipes/founder-branding-portrait.avif'
import authorPodcasterPortrait from '@/assets/style-recipes/author-podcaster-portrait.avif'
import socialLifestyleGlow from '@/assets/style-recipes/social-lifestyle-glow.avif'
import creatorStudioPortrait from '@/assets/style-recipes/creator-studio-portrait.avif'
import virtualSuitLook from '@/assets/style-recipes/virtual-suit-look.avif'
import streetwearEditorial from '@/assets/style-recipes/streetwear-editorial.avif'
import mediterraneanSummer from '@/assets/style-recipes/mediterranean-summer.avif'
import analogFilmSnapshot from '@/assets/style-recipes/analog-film-snapshot.avif'
import retro80sGlow from '@/assets/style-recipes/retro-80s-glow.avif'
import animeCharacterPortrait from '@/assets/style-recipes/anime-character-portrait.avif'
import fantasyHeroPortrait from '@/assets/style-recipes/fantasy-hero-portrait.avif'
import festiveHolidayGlow from '@/assets/style-recipes/festive-holiday-glow.avif'
import gymStrengthPortrait from '@/assets/style-recipes/gym-strength-portrait.avif'
import warmMaternityPortrait from '@/assets/style-recipes/warm-maternity-portrait.avif'
import minimalAestheticPortrait from '@/assets/style-recipes/minimal-aesthetic-portrait.avif'
import cleanProfileAvatar from '@/assets/style-recipes/clean-profile-avatar.avif'
import noirSciFiCity from '@/assets/style-recipes/noir-sci-fi-city.avif'
import thumbnailReactionShot from '@/assets/style-recipes/thumnail-reaction-shot.avif'

// Map filenames to imported images
const coverImageMap: Record<string, string> = {
  'wes-anderson.avif': wesAnderson,
  'ecomm-shine.avif': ecommShine,
  'founder-portrait.avif': founderPortrait,
  'flat-vector-social.avif': flatVectorSocial,
  'cute-3d-toy.avif': cute3dToy,
  'neon-nightlife.avif': neonNightlife,
  'watercolor-post.avif': watercolorPost,
  'lowpoly-3d.avif': lowpoly3d,
  'corporate-premium.avif': corporatePremium,
  'seasonal-boosters.avif': seasonalBoosters,
  'roger-deakins.avif': rogerDeakins,
  'neon-noir.avif': neonNoir,
  'pixar-vinyl-render.avif': pixarVinylRender,
  'studio-ghibli-watercolor.avif': studioGhibliWatercolor,
  'anthropologie-home-catalog.avif': anthropologieHomeCatalog,
  'high-fashion-editorial-portrait.avif': highFashionEditorialPortrait,
  'apple-keynote-product.avif': appleKeynoteProduct,
  'a24-elevated-horror.avif': a24ElevatedHorror,
  'natural-dating-profile.avif': naturalDatingProfile,
  'modern-corporate-portrait.avif': modernCorporatePortrait,
  'founder-branding-portrait.avif': founderBrandingPortrait,
  'author-podcaster-portrait.avif': authorPodcasterPortrait,
  'social-lifestyle-glow.avif': socialLifestyleGlow,
  'creator-studio-portrait.avif': creatorStudioPortrait,
  'virtual-suit-look.avif': virtualSuitLook,
  'streetwear-editorial.avif': streetwearEditorial,
  'mediterranean-summer.avif': mediterraneanSummer,
  'analog-film-snapshot.avif': analogFilmSnapshot,
  'retro-80s-glow.avif': retro80sGlow,
  'anime-character-portrait.avif': animeCharacterPortrait,
  'fantasy-hero-portrait.avif': fantasyHeroPortrait,
  'festive-holiday-glow.avif': festiveHolidayGlow,
  'gym-strength-portrait.avif': gymStrengthPortrait,
  'warm-maternity-portrait.avif': warmMaternityPortrait,
  'minimal-aesthetic-portrait.avif': minimalAestheticPortrait,
  'clean-profile-avatar.avif': cleanProfileAvatar,
  'noir-sci-fi-city.avif': noirSciFiCity,
  'thumbnail-reaction-shot.avif': thumbnailReactionShot,
}

export interface StyleRecipeSeed {
  name: string
  description: string
  adds: string[]
  negatives: string[]
  quality: string
  postProcess: string[]
  defaultImageType: 'photo' | 'illustration' | '3d_render'
  supportedImageTypes: ('photo' | 'illustration' | '3d_render')[]
  defaultShot: 'close_up' | 'medium' | 'wide' | 'aerial' | 'low' | 'high'
  defaultAngle: 'eye_level' | 'low' | 'high'
  suggestedShotChips: (
    | 'close_up'
    | 'medium'
    | 'wide'
    | 'aerial'
    | 'low'
    | 'high'
  )[]
  suggestedAngleChips: ('eye_level' | 'low' | 'high')[]
  coverImage?: string // filename of cover image asset (e.g., 'wes-anderson.avif')
  coverImageSrc?: string // imported image source
}

// Helper function to get cover image source
export function getCoverImageSrc(filename?: string): string | undefined {
  if (!filename) return undefined
  return coverImageMap[filename]
}

export const styleRecipesSeed: StyleRecipeSeed[] = [
  {
    name: 'Wes Anderson Still',
    // description:
    //   'Symmetrical, pastel-toned, storybook composition inspired by Wes Anderson film cinematography. Clean geometry, centered subjects, vintage palettes, and theatrical staging.',
    description:
      'Perfectly symmetrical world of pastel dreams, where every frame tells a story with theatrical precision and whimsical charm.',
    adds: [
      'perfect symmetry, centered composition',
      'pastel color palette (mint, mustard, rose, teal)',
      'flat, theatrical lighting with soft diffusion',
      'retro 1960s-1970s production design',
      'whimsical props arranged with geometric precision',
      'deadpan facial expressions',
      'minimal lens distortion, balanced frame',
      'set-like staging with clean backgrounds',
      'color-matched costumes and environment',
      'precise horizontal and vertical lines',
      'slightly elevated contrast but soft shadows',
      'storybook visual mood',
    ],
    negatives: [
      'gritty realism',
      'harsh shadows',
      'asymmetrical composition',
      'chaotic background',
      'dark moody color palettes',
      'strong depth blur',
      'handheld-camera look',
      'documentary-style clutter',
      'high saturation',
      'noir or dark cinematic tones',
    ],
    quality:
      'highly stylized, pastel-toned, cinematic still frame; theatrical lighting; crisp geometric staging; 4K filmic clarity',
    postProcess: [
      'slight grain',
      'color balancing toward pastel',
      'micro-contrast tuning',
    ],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'wide', 'close_up'],
    suggestedAngleChips: ['eye_level', 'high'],
    coverImage: 'wes-anderson.avif',
  },

  {
    name: 'Ecom Shine',
    // description:
    //   'Clean product shots on seamless/soft shadow, color-accurate, reflections optional, text-safe area.',
    description:
      'Showcase your products with pristine clarity on seamless backgrounds, where every detail shines and colors stay true.',
    adds: [
      'studio product shot',
      'clean seamless white or light gray background',
      'soft shadow beneath',
      'accurate colors',
      'natural reflection',
      'centered composition',
      'leave empty space for overlay text',
    ],
    negatives: [
      'blurry',
      'distorted logos',
      'warped text',
      'cluttered background',
      'incorrect colors',
    ],
    quality: 'ultra-realistic render, 4K, crisp lighting tuned for catalogs',
    postProcess: ['auto-upscale', 'background isolation if needed'],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['close_up', 'medium', 'wide'],
    suggestedAngleChips: ['eye_level', 'low'],
    coverImage: 'ecomm-shine.avif',
  },
  {
    name: 'Founder Portrait',
    // description:
    //   'Flattering editorial photo look, natural skin, stage/office lighting variants.',
    description:
      'Capture your leadership presence with editorial elegance, where professional lighting meets natural authenticity.',
    adds: [
      'editorial style headshot',
      'flattering professional lighting',
      'natural skin tones',
      'shallow depth of field',
      'office or conference stage background',
      'confident and approachable expression',
    ],
    negatives: ['overexposed skin', 'harsh shadows', 'unrealistic filters'],
    quality: 'photorealistic portrait lens, 85mm depth, HDR',
    postProcess: [],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['close_up', 'medium'],
    suggestedAngleChips: ['eye_level', 'high'],
    coverImage: 'founder-portrait.avif',
  },
  {
    name: 'Flat Vector Social',
    // description:
    //   'Bold flat/line art for carousels, brand-color bias, high readability.',
    description:
      'Bold, clean illustrations that pop on social feeds with vibrant colors and crystal-clear readability.',
    adds: [
      'bold flat vector illustration',
      'clean outlines',
      'limited color palette',
      'simplified shapes',
      'optimized for carousels/social posts',
      'space for text bubbles or captions',
    ],
    negatives: [
      'photo-realistic texture',
      'shading gradients',
      'cluttered background',
    ],
    quality: 'crisp vector/SVG-like output',
    postProcess: [],
    defaultImageType: 'illustration',
    supportedImageTypes: ['illustration'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'wide'],
    suggestedAngleChips: ['eye_level'],
    coverImage: 'flat-vector-social.avif',
  },
  {
    name: 'Cute 3D Toy',
    // description:
    //   'Soft plastic materials, studio lighting, pastel palette, mascot-friendly.',
    description:
      'Adorable vinyl-style characters come to life with soft pastels and playful charm, perfect for bringing mascots to life.',
    adds: [
      'adorable vinyl figure style',
      'rounded edges',
      'soft plastic material',
      'pastel palette',
      'studio lighting with gentle shadows',
      'playful mascot look',
    ],
    negatives: ['realistic skin texture', 'harsh lighting', 'scary features'],
    quality: '3D render, 8K details, Pixar-like shading',
    postProcess: [],
    defaultImageType: '3d_render',
    supportedImageTypes: ['3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'close_up'],
    suggestedAngleChips: ['eye_level', 'low'],
    coverImage: 'cute-3d-toy.avif',
  },
  {
    name: 'Neon Nightlife',
    // description: 'Urban neon, cinematic contrast, glare control.',
    description:
      'Immerse yourself in the electric energy of urban nights, where neon lights paint cinematic stories on wet streets.',
    adds: [
      'urban street at night',
      'neon signage glow',
      'cinematic color grading',
      'reflections on wet pavement',
      'dynamic lighting',
    ],
    negatives: ['overexposed neon', 'washed out details', 'daytime lighting'],
    quality: 'ultra-detailed HDR, 16:9 cinematic ratio',
    postProcess: [],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'wide',
    defaultAngle: 'low',
    suggestedShotChips: ['wide', 'aerial'],
    suggestedAngleChips: ['low', 'eye_level'],
    coverImage: 'neon-nightlife.avif',
  },
  {
    name: 'Watercolor Post',
    // description: 'Painterly promo scenes, white space preserved.',
    description:
      'Transform your visuals into hand-painted masterpieces with soft brush strokes and preserved artistic breathing room.',
    adds: [
      'hand-painted watercolor style',
      'soft brush strokes',
      'paper texture visible',
      'vibrant pigment flow',
      'preserved white space',
    ],
    negatives: ['photorealism', '3D plastic look', 'pixel art'],
    quality: 'high-res scan effect, subtle edge bleed simulation',
    postProcess: [],
    defaultImageType: 'illustration',
    supportedImageTypes: ['illustration'],
    defaultShot: 'wide',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'wide'],
    suggestedAngleChips: ['eye_level'],
    coverImage: 'watercolor-post.avif',
  },
  {
    name: 'Low-Poly 3D',
    // description: 'Playful geometric product/mascot renders.',
    description:
      'Embrace the playful charm of geometric simplicity, where clean shapes create memorable, toy-like characters.',
    adds: [
      'low-poly 3D render',
      'geometric simple shapes',
      'flat shading',
      'toy-like aesthetic',
    ],
    negatives: [
      'highly realistic detail',
      'complex textures',
      'smooth glossy renders',
    ],
    quality: 'crisp render with emphasized polygon count',
    postProcess: [],
    defaultImageType: '3d_render',
    supportedImageTypes: ['3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'wide'],
    suggestedAngleChips: ['eye_level', 'high'],
    coverImage: 'lowpoly-3d.avif',
  },
  {
    name: 'Corporate Premium',
    // description:
    //   'Muted palette, realistic office/lifestyle, conservative contrast, LinkedIn-ready.',
    description:
      'Elevate your professional presence with sophisticated, muted tones that speak confidence and corporate excellence.',
    adds: [
      'corporate lifestyle photography',
      'muted premium palette',
      'realistic office environment',
      'diverse team collaboration',
      'conservative contrast',
    ],
    negatives: ['overly saturated colors', 'cartoon style', 'harsh shadows'],
    quality: 'photorealistic, depth of field tuned for LinkedIn',
    postProcess: [],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'wide'],
    suggestedAngleChips: ['eye_level', 'high'],
    coverImage: 'corporate-premium.avif',
  },
  {
    name: 'Seasonal Boosters',
    // description: 'Rotating holiday/season accents layered on top of any Pack.',
    description:
      'Add festive magic to any style with seasonal touches that celebrate holidays and capture the essence of each season.',
    adds: [
      'festive accents for winter holidays',
      'bright floral accents for spring',
      'warm tones for summer',
      'autumn foliage palette',
    ],
    negatives: [],
    quality: 'applied contextually, preserves main pack intent',
    postProcess: [],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'wide'],
    suggestedAngleChips: ['eye_level'],
    coverImage: 'seasonal-boosters.avif',
  },

  /* ----------------------------------------------- */
  /* NEWLY ADDED STYLE RECIPES                       */
  /* ----------------------------------------------- */
  {
    name: 'Roger Deakins Natural Cinema',
    // description:
    //   'Photoreal cinematic imagery inspired by Roger Deakins: naturalistic lighting, controlled contrast, pristine composition, and subtle color discipline.',
    description:
      'Experience the masterful restraint of naturalistic cinema, where every light feels real and every frame tells a story.',
    adds: [
      'naturalistic lighting with soft directional source',
      'gentle diffusion and atmospheric depth',
      'precise composition with clean visual balance',
      'rich but restrained color grade',
      'film-like dynamic range',
      'crisp subject separation without exaggerated bokeh',
      'real-world textures and authentic surfaces',
    ],
    negatives: [
      'overly stylized color grading',
      'extreme saturation',
      'cartoonish contrast',
      'heavy digital sharpening',
      'chaotic composition',
      'artificial plastic skin',
    ],
    quality:
      '4K filmic clarity, natural grain, dynamic range tuned for cinematic realism',
    postProcess: ['subtle grain', 'slight warm-cool tonal balance'],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'wide', 'close_up'],
    suggestedAngleChips: ['eye_level', 'low'],
    coverImage: 'roger-deakins.avif',
  },
  {
    name: 'Blade Runner 2049 Neon Noir',
    // description:
    //   'Moody futurist neo-noir inspired by Blade Runner 2049: volumetric fog, glowing neons, monolithic architecture, and desaturated atmospherics.',
    description:
      'Step into a moody future where neon glows through fog, and monolithic architecture frames stories of tomorrow.',
    adds: [
      'neon-lit futuristic cityscapes',
      'volumetric fog and atmospheric diffusion',
      'moody high-contrast noir lighting',
      'ambient reflections on wet surfaces',
      'massive architectural scale',
      'desaturated tones with bold accent lighting',
      'sci-fi cinematic composition',
    ],
    negatives: [
      'sunny daylight',
      'bright cheerful colors',
      'flat lighting',
      'low-contrast scenes',
      'clean minimalist environments',
    ],
    quality:
      'HDR neon contrast, cinematic sci-fi texture, deep blacks with luminous highlights',
    postProcess: ['fog boost', 'neon glow enhancement'],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', '3d_render', 'illustration'],
    defaultShot: 'wide',
    defaultAngle: 'low',
    suggestedShotChips: ['wide', 'aerial', 'medium'],
    suggestedAngleChips: ['low', 'eye_level'],
    coverImage: 'neon-noir.avif',
  },
  {
    name: 'Pixar Vinyl Render',
    // description:
    //   'High-end Pixar-style 3D vinyl character render with cinematic lighting, soft edges, and expressive storytelling poses.',
    description:
      'Bring characters to life with Pixar-quality charm, where soft vinyl textures meet expressive poses and cinematic warmth.',
    adds: [
      'Pixar-inspired stylized proportions',
      'vinyl-like soft plastic surface',
      'bright expressive eyes and clear silhouettes',
      'cinematic rim lighting',
      'smooth subsurface scattering',
      'playful, emotionally readable poses',
      'warm family-friendly palette',
    ],
    negatives: [
      'realistic human textures',
      'harsh lighting',
      'horror or unsettling features',
      'gritty realism',
      'photographic skin pores',
    ],
    quality: '8K Pixar-style global illumination, soft cinematic shading',
    postProcess: ['subsurface scatter boost', 'soft shadow tuning'],
    defaultImageType: '3d_render',
    supportedImageTypes: ['3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'close_up'],
    suggestedAngleChips: ['eye_level', 'low'],
    coverImage: 'pixar-vinyl-render.avif',
  },
  {
    name: 'Studio Ghibli Watercolor',
    // description:
    //   'Hand-painted Ghibli-style backgrounds with soft atmospheric depth, warm palettes, and expressive magical realism.',
    description:
      'Enter a world of magical realism painted in soft watercolors, where every scene feels like a storybook come to life.',
    adds: [
      'painterly backgrounds with visible brush texture',
      'soft watercolor shading',
      'gentle pastel-inspired palette',
      'storybook magical realism',
      'lush natural environments',
      'warm emotional tone',
      'clean linework around characters',
    ],
    negatives: [
      'harsh shadows',
      'photo-real textures',
      'dark horror themes',
      'heavy outlines',
      'low-resolution watercolor bleed',
    ],
    quality: 'high-res watercolor effect with balanced pigment softness',
    postProcess: ['watercolor edge-blend', 'paper texture overlay'],
    defaultImageType: 'illustration',
    supportedImageTypes: ['illustration'],
    defaultShot: 'wide',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'wide'],
    suggestedAngleChips: ['eye_level'],
    coverImage: 'studio-ghibli-watercolor.avif',
  },
  {
    name: 'Anthropologie Home Catalog',
    // description:
    //   'Warm, curated lifestyle home photography with boho-chic styling, textured materials, and soft natural light.',
    description:
      'Curate a warm, inviting lifestyle aesthetic where boho-chic meets natural textures and soft, golden light.',
    adds: [
      'boho-chic home styling',
      'warm natural lighting',
      'soft earth-toned palettes',
      'layered textures (linen, rattan, ceramic)',
      'inviting lifestyle composition',
      'tasteful props arranged organically',
      'soft shadows and diffused highlights',
    ],
    negatives: [
      'stark modern minimalism',
      'cold lighting',
      'office environments',
      'over-saturated tones',
      'flat lifeless staging',
    ],
    quality: 'premium lifestyle catalog photography',
    postProcess: ['warm tone curve', 'subtle matte finish'],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo'],
    defaultShot: 'wide',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'wide'],
    suggestedAngleChips: ['eye_level'],
    coverImage: 'anthropologie-home-catalog.avif',
  },
  {
    // name: 'Vogue Editorial Portrait',
    name: 'High Fashion Editorial Portrait',
    // description:
    //   'High-fashion editorial portraiture with bold styling, controlled lighting, and striking composition.',
    description:
      'Channel the bold sophistication of high fashion with dramatic lighting, striking poses, and editorial polish.',
    adds: [
      'high-fashion posing',
      'dramatic editorial lighting',
      'luxury wardrobe and styling',
      'clean high-contrast composition',
      'sharp detail on facial features',
      'magazine-quality skin retouching',
      'professional studio backdrop',
    ],
    negatives: [
      'casual clothing',
      'flat amateur lighting',
      'low-fashion environments',
      'unretouched skin',
      'heavily stylized cartoons',
    ],
    quality:
      'ultra-high-end editorial clarity, 4K skin detail, studio contrast',
    postProcess: ['skin retouch pass', 'color grading for editorial polish'],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo'],
    defaultShot: 'close_up',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['close_up', 'medium'],
    suggestedAngleChips: ['eye_level', 'high'],
    coverImage: 'high-fashion-editorial-portrait.avif',
  },
  {
    name: 'Apple Keynote Product Shot',
    // description:
    //   'Ultra-clean hero product aesthetic: minimal composition, soft gradients, precision lighting, and premium materials.',
    description:
      'Showcase products with keynote-level precision, where minimalism meets premium materials in perfect harmony.',
    adds: [
      'minimalist hero composition',
      'soft gradient background',
      'precise product lighting',
      'premium metallic or glass materials',
      'floating or center-stage layout',
      'clean reflections and subtle shadows',
      'sharp product edges with smooth surfaces',
    ],
    negatives: [
      'busy backgrounds',
      'harsh contrast',
      'noisy textures',
      'cluttered props',
      'oversaturated colors',
    ],
    quality:
      '8K product render or DSLR-grade clarity; keynote-grade visual polish',
    postProcess: ['clean gradient smoothing', 'highlight refinement'],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', '3d_render'],
    defaultShot: 'close_up',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['close_up', 'medium'],
    suggestedAngleChips: ['eye_level'],
    coverImage: 'apple-keynote-product.avif',
  },
  {
    name: 'A24 Elevated Horror',
    // description:
    //   'Slow-burn atmospheric horror with natural light, empty spaces, emotional tension, and unsettling calm.',
    description:
      'Create atmospheric tension through empty spaces and natural light, where quiet moments become deeply unsettling.',
    adds: [
      'natural low-key lighting',
      'soft shadows with eerie diffusion',
      'empty negative space',
      'emotional stillness and tension',
      'muted cool-warm palette',
      'unsettling subtle details',
      'slow-cinema composition',
    ],
    negatives: [
      'gore',
      'jump-scare imagery',
      'overly bright scenes',
      'cartoonish horror stylization',
      'high-saturation color palettes',
    ],
    quality: 'cinematic grain, subdued contrast, 4K atmospheric realism',
    postProcess: ['grain pass', 'shadow-depth enhancement'],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'wide'],
    suggestedAngleChips: ['eye_level', 'low'],
    coverImage: 'a24-elevated-horror.avif',
  },
  {
    name: 'Tim Burton Gothic Whimsy',
    // description:
    //   'Gothic fantasy with elongated shapes, exaggerated silhouettes, cool palettes, and surreal whimsical mood.',
    description:
      'Embrace the surreal charm of gothic whimsy, where elongated shapes and cool palettes create fantastical stories.',
    adds: [
      'elongated gothic silhouettes',
      'pale cool-toned palette',
      'whimsical surreal props',
      'high-contrast rim lighting',
      'Tim Burton-style character proportions',
      'storybook gothic architecture',
      'moody atmospheric fog',
    ],
    negatives: [
      'realistic human proportions',
      'bright cheerful colors',
      'natural daylight environments',
      'clean corporate styling',
      'flat lighting',
    ],
    quality: 'high-contrast gothic cinematic rendering with stylized forms',
    postProcess: ['cool tone shift', 'fog enhancement'],
    defaultImageType: 'illustration',
    supportedImageTypes: ['illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'low',
    suggestedShotChips: ['medium', 'wide'],
    suggestedAngleChips: ['low', 'eye_level'],
    coverImage: 'natural-dating-profile.avif',
  },

  /* ----------------------------------------------- */
  /* NEW CATEGORY-ALIGNED STYLE RECIPES              */
  /* ----------------------------------------------- */

  //
  // 1. Career & Professional Headshots
  //
  {
    name: 'Modern Corporate Portrait',
    // description:
    //   'Clean, contemporary professional headshot with neutral backgrounds, soft directional lighting, and crisp business styling.',
    description:
      'Present your professional best with clean, contemporary styling that commands attention and builds trust.',
    adds: [
      'soft natural light from 45-degree angle',
      'neutral gray or warm beige backdrop',
      'subtle depth-of-field',
      'sharp, clean wardrobe (blazer, button-up)',
      'balanced skin tones and realistic detail',
      'professional, approachable expression',
    ],
    negatives: [
      'harsh shadows',
      'heavy color grading',
      'unprofessional wardrobe',
      'distracting background elements',
      'extreme highlights or blown-out whites',
    ],
    quality:
      'high clarity, studio-quality headshot with controlled lighting and professional color accuracy',
    postProcess: [
      'skin-tone balance',
      'soft sharpening',
      'contrast micro-adjust',
    ],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'close_up',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['close_up', 'medium'],
    suggestedAngleChips: ['eye_level'],
    coverImage: 'modern-corporate-portrait.avif',
  },
  {
    name: 'Founder Branding Portrait',
    // description:
    //   'Bright, confident startup-founder aesthetic with natural lighting, minimalistic backgrounds, and casual-smart styling.',
    description:
      'Radiate startup confidence with bright, natural lighting and casual-smart styling that tells your story authentically.',
    adds: [
      'clean tech-office or neutral backdrop',
      'warm daylight ambiance',
      'relaxed but confident energy',
      'soft contrast with clean edges',
      'startup-casual wardrobe: tees, sweaters, blazers',
      'balanced skin tones',
    ],
    negatives: [
      'heavy shadowing',
      'dark moody tones',
      'dramatic color grading',
      'busy office clutter',
      'oversaturated colors',
    ],
    quality:
      'balanced daylight portrait with crisp detail and startup-professional polish',
    postProcess: ['light skin retouch', 'cool/warm balance', 'subtle vignette'],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'close_up'],
    suggestedAngleChips: ['eye_level'],
    coverImage: 'founder-branding-portrait.avif',
  },
  {
    name: 'Author & Podcaster Portrait',
    // description:
    //   'Warm studio portrait with creative lighting, textured backdrops, and expressive character suitable for book covers or podcast branding.',
    description:
      'Capture your creative voice with warm, textured portraits that bring depth and character to your brand story.',
    adds: [
      'soft falloff lighting',
      'tan or charcoal textured backdrop',
      'slightly cinematic composition',
      'warm highlight rolloff',
      'balanced expressive pose',
    ],
    negatives: [
      'flat harsh frontal flash',
      'high saturation',
      'overly moody noir shadows',
      'cluttered studio equipment',
      'busy distracting colors',
    ],
    quality: 'studio-caliber clarity with warm cinematic tones',
    postProcess: ['soft grain', 'warm-tone shift', 'shadow recovery'],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'close_up'],
    suggestedAngleChips: ['eye_level', 'high'],
    coverImage: 'author-podcaster-portrait.avif',
  },

  //
  // 2. Dating & Social Portraits
  //
  {
    name: 'Natural Dating Profile',
    // description:
    //   'Warm, friendly dating-style portraits with daylight tones, outdoorsy backdrops, and authentic expressions.',
    description:
      'Show your authentic self with warm, friendly portraits that capture genuine moments in beautiful natural light.',
    adds: [
      'golden-hour lighting',
      'shallow depth-of-field',
      'casual authentic posing',
      'warm and flattering skin tones',
      'soft background blur',
    ],
    negatives: [
      'studio stiffness',
      'heavy makeup look',
      'overexposed highlights',
      'distracting elements in background',
      'aggressive filters',
    ],
    quality: 'flattering daylight portrait with natural detail',
    postProcess: ['skin-tone balancing', 'gentle contrast', 'warm hue shift'],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'close_up', 'wide'],
    suggestedAngleChips: ['eye_level', 'high'],
    coverImage: 'natural-dating-profile.avif',
  },
  {
    name: 'Social Lifestyle Glow',
    // description:
    //   'Bright lifestyle portraits with energetic ambiance, soft flare, and a candid social-media vibe.',
    description:
      'Radiate positive energy with bright, sun-kissed portraits that capture the vibrant spirit of modern lifestyle.',
    adds: [
      'sun-kissed highlights',
      'tasteful flares or backlight',
      'candid looking-away moments',
      'soft pastel wardrobe tones',
      'light bokeh background',
    ],
    negatives: [
      'heavy shadow contrast',
      'club-style lighting',
      'dark indoor scenes',
      'harsh direct flash',
      'desaturated color palettes',
    ],
    quality: 'warm lifestyle portrait with airy social-media polish',
    postProcess: [
      'light bloom',
      'warm highlight shifts',
      'micro contrast tuning',
    ],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'wide'],
    suggestedAngleChips: ['eye_level', 'high'],
    coverImage: 'social-lifestyle-glow.avif',
  },

  //
  // 3. Creator & Influencer Styles
  //
  {
    name: 'Creator Studio Portrait',
    // description:
    //   'Clean creator-style studio look with LED lighting, soft key fill, and a polished personal-brand aesthetic.',
    description:
      'Polish your creator brand with modern studio lighting that brings out your personality and professional edge.',
    adds: [
      'soft key + rim lighting',
      'colored LED accent lights',
      'creator-desk or minimalist studio backdrop',
      'sharp clothing detail',
      'youtuber/streamer energy',
    ],
    negatives: [
      'dark moody shadows',
      'film grain overlays',
      'heavy contrast grading',
      'messy room',
      'harsh single-point flash',
    ],
    quality: 'crisp studio portrait with modern creator lighting',
    postProcess: [
      'light sharpening',
      'color temperature balance',
      'LED accent boost',
    ],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'close_up'],
    suggestedAngleChips: ['eye_level'],
    coverImage: 'creator-studio-portrait.avif',
  },
  {
    name: 'Thumbnail Reaction Shot',
    // description:
    //   'High-energy reaction portrait with exaggerated expressions, bright lighting, and bold readability for thumbnails.',
    description:
      'Stop the scroll with high-energy expressions and bold lighting that make your thumbnails impossible to ignore.',
    adds: [
      'exaggerated expressive pose',
      'bright three-point lighting',
      'high contrast and clarity',
      'clean saturated color elements',
      'simple background for cropping',
    ],
    negatives: [
      'subtle low-energy expression',
      'dark dramatic lighting',
      'noisy cluttered backgrounds',
      'soft low-contrast looks',
      'muted palettes',
    ],
    quality: 'bright expressive portrait optimized for thumbnail clarity',
    postProcess: [
      'saturation lift',
      'micro-contrast boost',
      'clean edge enhancement',
    ],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'close_up',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['close_up', 'medium'],
    suggestedAngleChips: ['eye_level', 'high'],
    coverImage: 'thumbnail-reaction-shot.avif',
  },

  //
  // 4. Fashion & Virtual Try-On
  //
  {
    name: 'Virtual Suit Look',
    // description:
    //   'Sharp, tailored suit styling with studio-quality lighting and refined formal portraiture.',
    description:
      'Command respect with sharp, tailored elegance and studio-quality lighting that elevates your professional presence.',
    adds: [
      'cleanly tailored suit textures',
      'soft studio lighting',
      'neutral or charcoal backdrop',
      'controlled contrast',
      'crisply controlled shadows',
    ],
    negatives: [
      'low-quality cloth rendering',
      'high-saturation colors',
      'busy settings',
      'harsh overhead lighting',
      'casual streetwear',
    ],
    quality: 'high-end studio portrait with crisp wardrobe definition',
    postProcess: [
      'texture sharpening',
      'contrast refinement',
      'cool-tone balance',
    ],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'close_up'],
    suggestedAngleChips: ['eye_level'],
    coverImage: 'virtual-suit-look.avif',
  },
  {
    name: 'Streetwear Editorial',
    // description:
    //   'Fashion-forward streetwear portraits with bold angles, urban backgrounds, and style-centric composition.',
    description:
      'Make a statement with bold streetwear style, where urban textures meet fashion-forward angles and attitude.',
    adds: [
      'urban textures',
      'fashion-forward poses',
      'dynamic off-center framing',
      'layered outfits',
      'punchy color accents',
    ],
    negatives: [
      'clean corporate looks',
      'soft dreamy lighting',
      'rural backgrounds',
      'overly formal styling',
      'flat compositions',
    ],
    quality: 'high-fashion editorial with bold, modern edge',
    postProcess: ['selective contrast', 'texture boost', 'cool-grit toning'],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'low',
    suggestedShotChips: ['medium', 'wide', 'low'],
    suggestedAngleChips: ['low', 'eye_level'],
    coverImage: 'streetwear-editorial.avif',
  },

  //
  // 5. Travel & Lifestyle
  //
  {
    name: 'Mediterranean Summer',
    // description:
    //   'Bright sunlit coastal portraits with azure tones, soft stone textures, and relaxed vacation styling.',
    description:
      'Capture the essence of summer with bright coastal light, azure tones, and the relaxed elegance of Mediterranean life.',
    adds: [
      'sunny Mediterranean ambiance',
      'aqua and terracotta accents',
      'clean daylight shadows',
      'beach or stone-architecture backdrop',
      'warm and natural posing',
    ],
    negatives: [
      'rainy weather look',
      'dark interiors',
      'high-contrast gritty tones',
      'busy tourist crowds',
      'HDR overprocessing',
    ],
    quality: 'sunlit travel portrait with crisp colors and warm atmosphere',
    postProcess: ['warm highlights', 'saturation lift', 'soft clarity'],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'wide',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['wide', 'medium'],
    suggestedAngleChips: ['eye_level'],
    coverImage: 'mediterranean-summer.avif',
  },
  {
    name: 'Urban Night Vibes',
    // description:
    //   'Neon-lit city-night portraits with cinematic contrast, reflective surfaces, and crisp low-light performance.',
    description:
      'Embrace the electric pulse of city nights, where neon reflections create cinematic portraits full of urban energy.',
    adds: [
      'neon signage reflections',
      'soft rim lighting',
      'moody but readable shadows',
      'urban modern texture',
      'shallow night depth-of-field',
    ],
    negatives: [
      'daylight scenes',
      'blown highlights',
      'heavy film grain',
      'low-detail shadows',
      'flat indoor lighting',
    ],
    quality: 'cinematic night portrait with neon accents and crisp detail',
    postProcess: [
      'vibrancy tuning',
      'shadow cleanup',
      'cyan-magenta balancing',
    ],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'wide'],
    suggestedAngleChips: ['eye_level', 'low'],
    coverImage: 'neon-nightlife.avif',
  },

  //
  // 6. Creative & Retro Portraiture
  //
  {
    name: 'Analog Film Snapshot',
    // description:
    //   'Soft, nostalgic instant-film look with pastel roll-off, subtle grain, and casual framing.',
    description:
      'Capture moments with the soft, nostalgic charm of instant film, where every frame feels like a treasured memory.',
    adds: [
      'soft highlight blooming',
      'gentle film grain',
      'pastel color rolloff',
      'slight vignette',
      'imperfect, candid framing',
    ],
    negatives: [
      'highly digital sharpness',
      'punchy neon colors',
      'extreme shadows',
      'HDR processing',
      'clinical studio look',
    ],
    quality: 'gentle analog-style portrait with nostalgic tones',
    postProcess: ['grain overlay', 'vignette', 'pastel color shift'],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'close_up'],
    suggestedAngleChips: ['eye_level', 'high'],
    coverImage: 'analog-film-snapshot.avif',
  },
  {
    name: 'Retro 80s Glow',
    // description:
    //   'Vibrant retro portraits with neon-magenta lighting, soft bloom, and vintage synth-wave intensity.',
    description:
      'Channel the vibrant energy of the 80s with neon-magenta glow and synth-wave intensity that never goes out of style.',
    adds: [
      'magenta/cyan neon lighting',
      'soft lens bloom',
      'bold retro wardrobe styling',
      'graphic symmetrical elements',
      'high-energy posing',
    ],
    negatives: [
      'natural daylight scenes',
      'muted palettes',
      'cinematic color grading',
      'corporate attire',
      'low saturation',
    ],
    quality: 'retro neon portrait with bold 80s glow and crisp silhouettes',
    postProcess: ['neon bloom', 'saturation push', 'edge glow'],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'high',
    suggestedShotChips: ['medium', 'close_up', 'wide'],
    suggestedAngleChips: ['high', 'eye_level'],
    coverImage: 'retro-80s-glow.avif',
  },

  //
  // 7. Character & Fantasy Styles
  //
  {
    name: 'Anime Character Portrait',
    // description:
    //   'Soft cel-shaded anime portrait with stylized lighting, expressive eyes, and clean background gradients.',
    description:
      'Bring anime characters to life with expressive eyes, soft cel-shading, and clean gradients that pop with personality.',
    adds: [
      'smooth cel shading',
      'large expressive eyes',
      'clean gradient backgrounds',
      'bright character palettes',
      'soft glow highlights',
    ],
    negatives: [
      'realistic skin texture',
      'heavy film grain',
      'dark gritty tones',
      'photorealistic detail',
      'chaotic backgrounds',
    ],
    quality: 'clean stylized anime rendering with crisp lines',
    postProcess: ['cel-line sharpening', 'gradient smoothing'],
    defaultImageType: 'illustration',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'close_up'],
    suggestedAngleChips: ['eye_level', 'high'],
    coverImage: 'anime-character-portrait.avif',
  },
  {
    name: 'Fantasy Hero Portrait',
    // description:
    //   'High-fantasy character styling with dramatic lighting, textured armor or robes, and epic atmospheric backdrops.',
    description:
      'Step into epic fantasy realms with dramatic lighting, textured details, and atmospheric backdrops fit for legends.',
    adds: [
      'dramatic side lighting',
      'fantasy-inspired wardrobe',
      'misty or glowing atmospherics',
      'bold contrast and detail',
      'dynamic heroic posing',
    ],
    negatives: [
      'modern casual clothing',
      'clean studio backdrops',
      'soft pastel moods',
      'low contrast',
      'urban environments',
    ],
    quality:
      'epic fantasy portrait with dramatic detail and atmospheric effects',
    postProcess: ['atmospheric fog', 'highlight rolloff', 'contrast punch'],
    defaultImageType: '3d_render',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'low',
    suggestedShotChips: ['medium', 'wide', 'low'],
    suggestedAngleChips: ['low', 'eye_level'],
    coverImage: 'fantasy-hero-portrait.avif',
  },

  //
  // 8. Holiday & Event Portraits
  //
  {
    name: 'Festive Holiday Glow',
    // description:
    //   'Warm, cozy seasonal look with soft lights, gentle decorations, and friendly expressions.',
    description:
      'Celebrate the season with warm, cozy portraits that capture the joyful spirit of holidays and special moments.',
    adds: [
      'warm twinkling lights',
      'soft festive props',
      'cozy wardrobe textures',
      'gold-orange highlights',
      'gentle depth-of-field',
    ],
    negatives: [
      'cold blue tones',
      'harsh LED colors',
      'dramatic shadows',
      'overly busy decorations',
      'sharp harsh lighting',
    ],
    quality: 'warm inviting holiday portrait with soft glow',
    postProcess: ['warm shift', 'light bloom', 'soft grain'],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'close_up'],
    suggestedAngleChips: ['eye_level'],
    coverImage: 'festive-holiday-glow.avif',
  },

  //
  // 9. Fitness & Wellness
  //
  {
    name: 'Gym Strength Portrait',
    // description:
    //   'High-contrast fitness portrait with sculpted lighting, defined highlights, and gym-environment textures.',
    description:
      'Showcase your strength with high-contrast lighting that sculpts definition and captures the power of your journey.',
    adds: [
      'directional top lighting',
      'defined muscle highlight',
      'matte background textures',
      'sweat glow detail',
      'powerful stance',
    ],
    negatives: [
      'soft dreamy lighting',
      'fashion wardrobe',
      'beach backdrops',
      'flat frontal flash',
      'low contrast',
    ],
    quality: 'sharp, high-contrast fitness portrait with sculpted lighting',
    postProcess: [
      'clarity boost',
      'shadow deepening',
      'sweat highlight polish',
    ],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'low',
    suggestedShotChips: ['medium', 'close_up'],
    suggestedAngleChips: ['low', 'eye_level'],
    coverImage: 'gym-strength-portrait.avif',
  },

  //
  // 10. Family, Couples & Milestones
  //
  {
    name: 'Warm Maternity Portrait',
    // description:
    //   'Soft, glowing maternity portrait with elegant posing, warm highlights, and gentle emotional ambiance.',
    description:
      'Celebrate this beautiful journey with soft, glowing portraits that capture the gentle warmth and elegance of motherhood.',
    adds: [
      'warm directional soft light',
      'gentle hand placement',
      'clean background or flowing fabric',
      'subtle glow',
      'elegant posture',
    ],
    negatives: [
      'high contrast shadows',
      'busy environmental clutter',
      'cold blue lighting',
      'aggressive sharpening',
      'dramatic posing',
    ],
    quality: 'soft, warm maternity portrait with elegant natural emotion',
    postProcess: ['warm hue shift', 'soft glow', 'edge smoothing'],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['medium', 'wide'],
    suggestedAngleChips: ['eye_level'],
    coverImage: 'warm-maternity-portrait.avif',
  },

  //
  // 11. Avant-Garde & Artistic Styles
  //
  {
    name: 'Minimal Aesthetic Portrait',
    // description:
    //   'Clean minimalism with soft color palettes, open negative space, and quiet editorial composition.',
    description:
      'Embrace the power of simplicity with clean minimalism, soft palettes, and quiet elegance that speaks volumes.',
    adds: [
      'large negative space',
      'soft pastel palette',
      'simple wardrobe',
      'studio smooth lighting',
      'calm clean posing',
    ],
    negatives: [
      'clutter',
      'complex backgrounds',
      'harsh contrast',
      'neon colors',
      'dramatic angles',
    ],
    quality: 'minimalist editorial portrait with refined softness',
    postProcess: ['pastel tuning', 'highlight smoothing', 'soft-film grain'],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['close_up', 'medium', 'wide'],
    suggestedAngleChips: ['eye_level', 'high'],
    coverImage: 'minimal-aesthetic-portrait.avif',
  },

  //
  // 12. Avatars & Social Personas
  //
  {
    name: 'Clean Profile Avatar',
    // description:
    //   'Simple, high-readability avatar portrait with smooth backgrounds, balanced lighting, and crisp edge clarity.',
    description:
      'Create the perfect profile image with clean simplicity, balanced lighting, and crisp clarity that stands out anywhere.',
    adds: [
      'clean gradient backdrop',
      'balanced lighting',
      'soft shadow under chin',
      'smooth edge definition',
      'calm expression',
    ],
    negatives: [
      'busy textures',
      'dramatic studio setups',
      'harsh color grading',
      'heavy retouching',
      'low readability',
    ],
    quality: 'crisp avatar-style portrait optimized for small-size clarity',
    postProcess: [
      'edge sharpening',
      'color smoothing',
      'subtle background blur',
    ],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'close_up',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['close_up'],
    suggestedAngleChips: ['eye_level'],
    coverImage: 'clean-profile-avatar.avif',
  },

  //
  // 13. Cinematic Worlds & Scenes
  //
  {
    name: 'Neon Sci-Fi City',
    // description:
    //   'Futuristic sci-fi portrait with holographic lighting, glowing accents, and high-tech city backdrops.',
    description:
      'Step into tomorrow with futuristic portraits where holographic light meets high-tech cityscapes of the future.',
    adds: [
      'holographic rim light',
      'neon ambient colors',
      'futuristic cityscape',
      'clean high-tech textures',
      'dramatic contrast',
    ],
    negatives: [
      'natural warm daylight',
      'rural backgrounds',
      'soft pastel palettes',
      'grainy film style',
      'low contrast',
    ],
    quality: 'hyper-modern sci-fi portrait with crisp neon lighting',
    postProcess: ['neon bloom', 'cyan-magenta tuning', 'shadow cleanup'],
    defaultImageType: '3d_render',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'low',
    suggestedShotChips: ['medium', 'wide'],
    suggestedAngleChips: ['low', 'eye_level'],
    coverImage: 'noir-sci-fi-city.avif',
  },

  //
  // 14. Product, Beauty & Food
  //
  {
    name: 'Clean Catalog Product Shot',
    // description:
    //   'Minimal, studio-lit product photography with crisp shadows, accurate textures, and pure-background isolation.',
    description:
      'Present products with catalog perfection, where crisp details and pure backgrounds let your items shine.',
    adds: [
      'pure white or neutral backdrop',
      'soft shadow grounding',
      'crisp edges and detail',
      'true-to-life surface textures',
      'clean studio illumination',
    ],
    negatives: [
      'colorful backdrops',
      'lens distortion',
      'busy tabletop scenes',
      'dramatic moody lighting',
      'blurred edges',
    ],
    quality: 'high-clarity studio product shot optimized for e-commerce',
    postProcess: ['edge cleanup', 'white-balance tuning', 'contrast smoothing'],
    defaultImageType: 'photo',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'close_up',
    defaultAngle: 'eye_level',
    suggestedShotChips: ['close_up', 'wide'],
    suggestedAngleChips: ['eye_level'],
    coverImage: 'ecomm-shine.avif',
  },

  //
  // 15. Fun, Viral & Community Styles
  //
  {
    name: 'Playful Aesthetic Pop',
    // description:
    //   'Bright, colorful portrait with bold pastels, pop-art energy, and fun expressive posing.',
    description:
      'Inject fun and energy into your portraits with bold pastels and pop-art vibes that celebrate playful expression.',
    adds: [
      'bold pastel palette',
      'clean studio color blocks',
      'expressive, playful posing',
      'soft even lighting',
      'punchy low-contrast shadows',
    ],
    negatives: [
      'moody dramatic lighting',
      'desaturated looks',
      'dark gritty textures',
      'formal wardrobe',
      'complex shadow work',
    ],
    quality: 'playful bright portrait with pop-art inspired tones',
    postProcess: ['pastel tuning', 'soft bloom', 'highlight balancing'],
    defaultImageType: 'illustration',
    supportedImageTypes: ['photo', 'illustration', '3d_render'],
    defaultShot: 'medium',
    defaultAngle: 'high',
    suggestedShotChips: ['medium', 'close_up'],
    suggestedAngleChips: ['high', 'eye_level'],
    coverImage: 'flat-vector-social.avif',
  },
]
